import API from './API.js'
import axios from 'axios'

export default class Languages extends API {
  constructor() {
    super('languages')
  }
  // /getActivelanguages
  async GetActivelanguages() {
     const response = await axios.get(`/getActivelanguages`)
     return response.data
  }
}
